var show_no_attachement_msg = function(){
    if ( $(this).closest(".js-med-docs-table").find("tr.js-med-doc-container:visible").length == 0 )
        $(this).closest(".js-med-docs-table").find(".js-no-attachments").show();
}

var delete_medical_document = function(event) {
    event.preventDefault();
    var $target = $(event.currentTarget || event.target);
    var $container = $target.closest(".js-med-doc-container");
    var is_new_document = !$(".js-med-doc-id", $container).val();

    if(is_new_document) {
        var $table = $container.closest(".js-med-docs-table");
        $container.slideUp("normal", function() {
            $(this).remove();

            if ($table.find("tr.js-med-doc-container:visible").length == 0) {
                $table.find(".js-no-attachments").show();
            }
        });
    } else {
        $(".js-med-doc-destroy", $container).val(true)
        $container.slideUp("normal", show_no_attachement_msg);
    }
}

var update_medical_document_label = function(event) {
  var file_name = "Upload medical document";
  if (this.files && this.files.length > 0) {
    file_name = this.files[0].name;
  }

  $(this).closest("label").find(".js-med-doc-filename").text(file_name);
}

var add_medical_document = function() {
  $("body").off("click", ".js-add-med-doc");
  $("body").on("click", ".js-add-med-doc", function(event) {
    event.preventDefault();

    var content = $(this).data('partial');
    var new_id = new Date().getTime();
    var input_names = /\[medical_documents_attributes\]\[\d+\]/g;
    var input_ids = /_medical_documents_attributes_\d+/g;
    content = content.replace(input_names, "[medical_documents_attributes][" + new_id + "]");
    content = content.replace(input_ids, "_documents_attributes_" + new_id);

    $(this).closest(".js-med-docs-table").find(".js-med-docs-container").append(content);
    $(this).closest(".js-med-docs-table").find(".js-no-attachments").hide();
  });

  $("body").off("click", ".js-delete-med-doc");
  $("body").on("click", ".js-delete-med-doc", delete_medical_document);

  $("body").off("change", ".js-med-doc-input");
  $("body").on("change", ".js-med-doc-input", update_medical_document_label);
}

$(document).ready(add_medical_document);
$(document).on('page:load', add_medical_document)